import { Colors } from '../consts/Colors';
import { Scales } from '../consts/Scales';

export default class LifeCount extends Phaser.GameObjects.Container {
    constructor(scene, score) {
        super(scene, scene.cameras.main.width / 2, 45, []);

        this.scene = scene;
        scene.add.existing(this);

        this.score = score;
        // console.log("score", this.score)

        const spacing = 70;
        this.firstLife = this.scene.add
            .image(-spacing, 0, 'heartFull')
            .setOrigin(0.5)
            .setScale(0.4);
        this.secondLife = this.scene.add.image(0, 0, 'heartFull').setOrigin(0.5).setScale(0.4);
        this.thirdLife = this.scene.add.image(spacing, 0, 'heartFull').setOrigin(0.5).setScale(0.4);

        this.add(this.firstLife);
        this.add(this.secondLife);
        this.add(this.thirdLife);
        if (this.score === 1) {
            this.setEmpty(this.firstLife);
        } else if (this.score === 2) {
            this.setEmpty(this.secondLife);
            this.setEmpty(this.firstLife);
        } else if (this.score === 3) {
            this.setEmpty(this.thirdLife);
        }
    }
    setEmpty(item) {
        this.scene.time.addEvent({
            delay: 500,
            callback: () => {
                item.setTexture('heartEmpty');
                this.scene.time.addEvent({
                    delay: 300,
                    callback: () => {
                        item.setTexture('heartFull');
                        this.scene.time.addEvent({
                            delay: 300,
                            callback: () => {
                                item.setTexture('heartEmpty');
                                this.scene.time.addEvent({
                                    delay: 300,
                                    callback: () => {
                                        item.setTexture('heartFull');
                                        this.scene.time.addEvent({
                                            delay: 300,
                                            callback: () => {
                                                item.setTexture('heartEmpty');
                                            },
                                        });
                                    },
                                });
                            },
                        });
                    },
                });
            },
        });
        item.setTexture('heartEmpty');
    }
}
